// extracted by mini-css-extract-plugin
module.exports = {"searchFormContainer":"SearchFormWrapper_searchFormContainer__2x34l","fullInput":"SearchFormWrapper_fullInput__1luwV"};